module.exports = __webpack_public_path__ + "static/img/loading.d6a1953.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indexImage/loading.gif
// module id = uRsJ
// module chunks = 1